import { useInstance } from '@meraki-internal/react-dependency-injection';
import { State, useSubscription } from '@meraki-internal/state';
import { BasicHeader } from './components/BasicHeader';
//import { createUseStyles } from 'react-jss';
import { useEffect } from 'react';
import { IHeaderTabGroup } from './HeaderTabs';

/* const useStyles = createUseStyles({
    buttons: {
        display: 'flex',
        alignItems: 'center'
    },

    optionalButtons: {
        display: 'flex',
        alignItems: 'center',
        height: 30,

        '&:empty': {
            border: 'none!important'
        }
    }
}); */

export const HEADER_HEIGHT = 57;
export const HEADER_Z_INDEX = 10;

interface IAppHeaderOverrideProps {
    title?: string | React.ReactNode;
    hidden?: boolean;
    tabs?: IHeaderTabGroup;
    fullWidth?: boolean;
    hidesBeaButton?: boolean;
}

export class AppHeaderOverrideState extends State<Record<string, never>> {

    private lastSet: number = Date.now();

    set = ({ title, hidden, tabs, fullWidth, hidesBeaButton }: IAppHeaderOverrideProps) => {
        this.title = title;
        this.hidden = hidden;
        this.tabs = tabs;
        this.fullWidth = fullWidth;
        this.hidesBeaButton = hidesBeaButton;

        this.lastSet = Date.now();

        this.setState({ });
    };

    clear = () => {
        const lastSet = this.lastSet;

        // to avoid header flicker, when we unload wait a moment,
        // and only clear state if set() has not been called again
        setTimeout(() => {
            if (this.lastSet === lastSet) {
                this.title = undefined;
                this.hidden = undefined;
                this.tabs = undefined;
                this.fullWidth = undefined;
                this.hidesBeaButton = undefined;
                this.setState({ });
            }
        }, 500);
    };

    title?: string | React.ReactNode;
    hidden?: boolean;
    showCareMapConfig?: boolean;
    tabs?: IHeaderTabGroup;
    fullWidth?: boolean;
    hidesBeaButton?: boolean;
}


/**
 * AppHeaderOverride will not detect changes so if you want to be able to dynamically alter the override
 * over time, then refactor useEffect dependencies below
 */
export const AppHeaderOverride: React.FC<IAppHeaderOverrideProps> = (props) => {
    const override = useInstance(AppHeaderOverrideState);

    useEffect(() => {
        override.set(props);
        return () => {
            override.clear();
        };

        // ideally we'd pass in props.title, props.hidden, ...
        // but until we need to support dynamic AppHeaderOverride
        // it isn't necessary
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return null;
};

export const AppHeader: React.FC<{title?: string | React.ReactNode}> = ({ title }) => {
    //const classes = useStyles();
    const override = useInstance(AppHeaderOverrideState);
    useSubscription(() => override);

    title = override.title || title || '';

    if (override.hidden) {
        return null;
    }

    return (
        <BasicHeader tabs={override.tabs}
            fullWidth={override.fullWidth}
            hidesBeaButton={override.hidesBeaButton}
            title={(
                <span data-id="app-header-title">{title}</span>
            )}
        >
            {/* In case we want to add header buttons */}
            {/* <div data-id="header-buttons" slot="end" className={classes.buttons}>
                <div className={classes.optionalButtons}>

                </div>
            </div> */}
        </BasicHeader>
    );
};
